module.exports = __webpack_public_path__ + "static/img/passo4.663b12fb.svg";